import { joinUrl } from "./url";

const startLog = location.href.indexOf('rl=1') !== -1
let timer = null
const items = []
function sendRequestLog(item: {
    method: string;
    url: string;
    header?: any;
    testName?: string;
    apiName?: string;
    data?: any;
}) {
    items.push(item)
    clearTimeout(timer)
    timer = setTimeout(() => {
        window.taroRawSdk.miniProgram.postMessage({
            data: {
                type: 'request_log',
                items: JSON.parse(JSON.stringify(items))
            }
        })
        items.length = 0
    }, 100)
}


export function addRequestLog(config) {
    if (!startLog) return

    let {
        apiName = '',
        testName = ''
    } = (config || {}) as any;

    // url 处理
    let url = config.url;
    if (!/^http/.test(url)) {
        url = joinUrl(config.baseURL, config.url)
        if (!/^http/.test(url)) {
            url = joinUrl(location.origin, url)
        }
    }

    // formData处理
    let data = config.data;
    if (config.data instanceof FormData) {
        const formData = [...config.data.entries()].reduce((obj, item) => {
            obj[item[0]] = item[1]
            return obj
        }, {})
        data = {
            formData
        }
    }
    const requestConfig = {
        method: config.method,
        url,
        header: config.headers,
        data,
        apiName,
        testName
    }

    console.log(requestConfig)

    sendRequestLog(requestConfig)
}